module.exports = __webpack_public_path__ + "media/05.cc65f72a.mp3";